import { useEventContext } from 'contexts';

export const EventLogo = () => {
    const event = useEventContext();

    return (
        <>
            {!!event?.logo_url && (
                <div className="event-logo-wrapper">
                    <img src={event.logo_url!} className="event-logo" alt="event logo" />
                </div>
            )}
        </>
    );
};
